import React, { useState, useEffect } from "react";
import { padStart } from "lodash";
import Button from "Button";
import Icon from "Icon";

const CashPayment = ({
  order,
  onBack,
  onComplete,
  isCompletingOrder = false,
  setParentChangeDue
}) => {
  const [cashAmount, setCashAmount] = useState("");
  const [changeDue, setChangeDue] = useState("$0.00");
  const [currentView, setCurrentView] = useState("cash");

  const formatCurrency = (amount) => {
    const paddedAmount = padStart(amount, 3, "0");
    const decimalPosition = paddedAmount.length - 2;
    return "$" + paddedAmount.slice(0, decimalPosition) + "." + paddedAmount.slice(decimalPosition);
  };

  const addAmount = (amount) => {
    const newAmount = `${cashAmount}${amount}`;
    const changeAmount = formatCurrency((parseInt(newAmount) - order.totalCents));
    setCashAmount(newAmount);
    setChangeDue(changeAmount);
  };

  const addCashAmount = (dollarAmount) => {
    const centsToAdd = dollarAmount * 100;
    const currentCents = parseInt(cashAmount || "0");
    const newAmount = (currentCents + centsToAdd).toString();
    const changeAmount = formatCurrency((parseInt(newAmount) - order.totalCents));
    setCashAmount(newAmount);
    setChangeDue(changeAmount);
  };

  const handleBack = () => {
    setCashAmount("");
    setChangeDue("$0.00");
    setCurrentView("cash");
    onBack();
  };

  const handleComplete = () => {
    setParentChangeDue(changeDue)
    onComplete();
  };

  const views = {
    cash: (
      <div>
        <div className="columns">
          <div className="column">
            <p className="subtitle">Order Total: ${order?.total}</p>
            <div className="columns">
              <div className="column is-bordered">
                <div className="field">
                  <label className="label">Cash Amount</label>
                  <input
                    type="text"
                    readOnly
                    value={formatCurrency(cashAmount)}
                    className="input is-size-4"
                  />
                </div>
              </div>
              <div className="column is-narrow">
                <div className="field">
                  <span className="label">&nbsp;</span>
                  <Button
                    onClick={() => setCashAmount("")}
                    text="Clear"
                  />
                </div>
              </div>
            </div>
            <div className="columns is-multiline mt-2">
              {[1, 5, 10, 25, 50, 100].map((amount) => {
                return (
                  <div
                    key={amount}
                    className="column is-one-third p-1"
                  >
                    <Button
                      className="is-fullwidth is-size-4"
                      onClick={() => addCashAmount(amount)}
                      text={`$${amount}`}
                    />
                  </div>
                );
              })}
            </div>
          </div>
          <div className="column">
            <div className="columns is-multiline is-centered">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0, "00"].map((amount, i) => {
                return (
                  <div
                    key={i}
                    className="column is-one-third is-primary p-1"
                  >
                    <Button
                      className="is-fullwidth is-size-4"
                      onClick={() => addAmount(amount)}
                      text={amount}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="is-flex mt-4">
          <Button
            className="is-size-4"
            color="red"
            onClick={handleBack}
            text="Back"
          />
          <Button
            className="ml-auto is-size-4"
            onClick={() => setCurrentView("change")}
            disabled={(order?.totalCents || 0) - parseInt(cashAmount || "0") > 0}
            text="Next"
          />
        </div>
      </div>
    ),
    change: (
      <div>
        <p className="subtitle">Cash Amount {formatCurrency(cashAmount)}</p>
        <p className="subtitle">Order total ${order?.total}</p>
        <p className="subtitle">Change Due {changeDue}</p>

        <div className="is-flex mt-4">
          <Button
            color="red"
            className="is-size-4"
            onClick={() => setCurrentView("cash")}
            loading={isCompletingOrder}
            text="Back"
          />
          <Button
            color="green"
            className="ml-auto is-size-4"
            onClick={handleComplete}
            loading={isCompletingOrder}
            text="Complete Order"
          />
        </div>
      </div>
    )
  };

  return views[currentView];
};

export default CashPayment;
